export default __webpack_public_path__ + "static/media/logotype.8e38c9b4.png";